//Очищает номер телефона от лишних символов
export default {
    methods: {
        phoneFormatting(phone) {
            let phoneArr = []

            for (let i = 0; i < phone.length; i++) {
                if (i !== 1) {
                    if (!isNaN(phone[i]) && phone[i] !== '') {
                        phoneArr.push(phone[i])
                    }
                }
            }
        
            return phoneArr.join('').replace(/\s+/g, '')
        }
    }
}